import React from 'react';
import { Link } from 'react-router-dom';
import { translations } from '../utils/translations';

const About = ({ language = 'en' }) => {
  const t = translations[language];
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-image">
          <img 
            src="https://images.unsplash.com/photo-1757264119016-7e6b568b810d" 
            alt="Modern Luxury Architecture"
          />
          <div className="about-hero-overlay"></div>
        </div>
        <div className="about-hero-content">
          <p className="page-overline">{t.about.overline}</p>
          <h1>{t.about.title}</h1>
        </div>
      </section>

      {/* Brand Story Section */}
      <section className="brand-story-section">
        <div className="section-container narrow">
          <div className="story-content">
            <p className="story-intro">
              {t.about.intro}
            </p>
            
            <p>
              {t.about.paragraph1}
            </p>

            <p>
              {t.about.paragraph2}
            </p>

            <p>
              {t.about.paragraph3}
            </p>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="philosophy-image-bg">
          <img 
            src="https://images.unsplash.com/photo-1621293954908-907159247fc8" 
            alt="Luxury Interior Detail"
          />
        </div>
        <div className="section-container">
          <div className="philosophy-content">
            <p className="section-overline">{t.about.philosophyOverline}</p>
            <h2>{t.about.philosophyTitle}</h2>
            
            <div className="philosophy-text">
              <p>
                {t.about.philosophyP1}
              </p>
              
              <p>
                {t.about.philosophyP2}
              </p>
              
              <p>
                {t.about.philosophyP3}
              </p>

              <p>
                {t.about.philosophyP4}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section">
        <div className="section-container narrow">
          <div className="experience-stats">
            <div className="stat">
              <h3>20+</h3>
              <p>{t.about.stat1Label}</p>
            </div>
            <div className="stat">
              <h3>€500K</h3>
              <p>{t.about.stat2Label}</p>
            </div>
            <div className="stat">
              <h3>20+</h3>
              <p>{t.about.stat3Label}</p>
            </div>
          </div>
        </div>
      </section>

      {/* About CTA Section */}
      <section className="about-cta-section">
        <div className="about-cta-content">
          <h2>{t.about.ctaTitle}</h2>
          <p>{t.about.ctaDescription}</p>
          <Link to="/contact" className="cta-button">
            {t.about.ctaButton}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
